import React, { useState } from 'react';

import { PhonesInput } from '../../../components';
import { Copy, Loading } from '../../../components';
import { Card, Form, FormItem } from '../../../components';
import { useAgentTelephony } from '../hooks/useAgentTelephony';
import { usePermissionAllowed } from '../../../hooks';
import { PERMISSIONS } from '../../../shared/constants/permissions';
import type { AgentTelephonyFormType } from '../hooks/useAgentTelephony';

export type TelephonyTabProps = {
  agentId: string;
  disabled?: boolean;
};

const TelephonyForm: React.FC<
  ReturnType<typeof useAgentTelephony> & { disabled?: boolean }
> = ({
  form,

  disabled,
  updating,

  addInboundPhonenumber,
  deleteInboundPhonenumber,
}) => {
  const [values, setValues] = useState(form);
  const sipUrl = process.env.REACT_APP_SIP_URL || 'unset';
  const isDisabled = !usePermissionAllowed([PERMISSIONS.MANAGE_SIP_TRUNK]);

  return (
    <Form<AgentTelephonyFormType> initialValue={values} onChange={setValues}>
      <div className="flex flex-col mt-md gap-y-md max-w-[50rem] mx-auto">
        <Card
          collapsable
          size="unset"
          withOverflow={false}
          defaultCollapsed={false}
          name="telephony.inb.card2"
          contentClassName="flex flex-col gap-y-md"
          title="1. Configure your SIP trunk provider"
          subtitle="Copy and paste to your sip trunk provider"
        >
          <div className="flex flex-row justify-between items-center">
            <span className="text-small font-medium">Sip Trunk URI</span>
            <Copy label="Copy" className="text-buttonPrimary" text={sipUrl} />
          </div>
          <div className="text-small font-semibold">{sipUrl}</div>
        </Card>
        <Card
          collapsable
          size="unset"
          withOverflow={false}
          defaultCollapsed={false}
          name="telephony.inb.card2"
          title="2. Define phone numbers"
          contentClassName="flex flex-col gap-y-md"
          subtitle="Numbers from your SIP trunk provider the agent will answer"
        >
          <FormItem<AgentTelephonyFormType>
            name="inboundPhones"
            label="Phone number"
            inline={false}
          >
            <PhonesInput
              disabled={disabled || isDisabled}
              loading={updating}
              values={form.inboundPhones}
              onAdd={addInboundPhonenumber}
              onDelete={deleteInboundPhonenumber}
            />
          </FormItem>
        </Card>
      </div>
    </Form>
  );
};

const TelephonyTab: React.FC<TelephonyTabProps> = ({ agentId, disabled }) => {
  const { loading, ...rest } = useAgentTelephony(agentId);

  if (loading) return <Loading />;

  return <TelephonyForm loading={loading} disabled={disabled} {...rest} />;
};

export default React.memo(TelephonyTab) as typeof TelephonyTab;
